import { CommandDefinition } from '../../../concepts/commands/CommandDefinition';
import { Component, Convention } from '../../../concepts/objects';
import { Point } from '../../../platform/geom/Point';
import { Physical } from './Physical';

export interface DropGuide {
    readonly points: Point[];
    readonly style?: 'default' | 'thick';
}

export interface DropInfo {
    readonly target: DropTarget;
    readonly guides: DropGuide[];
    readonly command: CommandDefinition<[string, string[]]>;
}

export interface DropTarget extends Physical {

    queryDrop(mpt: Point, subjects: Iterable<Component>): DropInfo | null;
}

export const DropTarget = new Convention<DropTarget>('DropTarget');
